import { Controller } from "@hotwired/stimulus";

// Clears cart data from localStorage once a Stripe payment succeeds.
export default class extends Controller {
  static targets = ["completedAt"];

  connect() {
    // Defensive guard for non-browser contexts.
    if (typeof window === "undefined") return;

    this.localizeCompletedAt();

    try {
      localStorage.removeItem("cart");
      localStorage.removeItem("cart_etag");
      localStorage.removeItem("prices");
      localStorage.removeItem("products");
    } catch (_) {
      // Fail quietly if localStorage is unavailable.
    }
  }

  localizeCompletedAt() {
    if (!this.hasCompletedAtTarget) return;

    const completedAt = new Date(this.completedAtTarget.dateTime);
    if (Number.isNaN(completedAt.getTime())) return;

    this.completedAtTarget.textContent = new Intl.DateTimeFormat(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short"
    }).format(completedAt);
  }
}
